@for (dataItem of items; track dataItem; let index = $index) {
  <pnkl-security-item
    #securityItem
    (itemSelected)="itemSelected($event)"
    (keydown)="arrowKeysHandler($any(index))"
    [dataItem]="dataItem"
    [searchText]="searchText()"
    [tabindex]="index"
  />
  <hr class="border-only" />
}
